export default __webpack_public_path__ + "static/media/Kempegowda.4dd4930e.png";